module.exports = __webpack_public_path__ + "img/img_mainland_account_open_6.5cd6d558.png";